module.exports = __webpack_public_path__ + "img/icon-mail.bf7d967b.svg";